import { Configuration, PopupRequest, PublicClientApplication } from '@azure/msal-browser';

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: '/auth',
    postLogoutRedirectUri: '/logout',
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  // Extra scope for getting the user photo
  // scopes: ['User.Read', 'ProfilePhoto.Read.All'],
  scopes: ['User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
